import React from 'react';

import InputLabel from 'components/inputfields/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import IProduct, { SalesTypeEnum } from 'models/product';
import ThreeWaySwitch from 'components/inputfields/ThreeWaySwitch';
import { SALES_TYPE_LABEL, salesTypes } from 'components/constants-ts';
interface ISalesTypeDataProps {
  readOnly?: boolean;
  approve?: boolean;
  state: IProduct;
  setState: React.Dispatch<React.SetStateAction<IProduct>>;
}

const SalesType = ({ readOnly, approve, state, setState }: ISalesTypeDataProps) => {
  return (
    <div style={{ width: '100%' }}>
      <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
        <div style={{ flexGrow: 1 }}>
          <FormControl disabled={readOnly} component="fieldset">
            <InputLabel heading={SALES_TYPE_LABEL} />
            <RadioGroup
              value={state?.salesType || null}
              name="salesType"
              style={{ flexDirection: 'row', gridGap: 16 }}
              onChange={event => setState({ ...state, salesType: event.target.value as unknown as SalesTypeEnum })}
            >
              {salesTypes.map(({ value, displayName }) => (
                <FormControlLabel key={value} value={value} control={<Radio color="primary" />} label={displayName} />
              ))}
            </RadioGroup>
          </FormControl>
        </div>
        {approve && state?.approve?.find(x => x.field === 'salesType') && (
          <ThreeWaySwitch
            readOnly={readOnly}
            state={state}
            setState={setState}
            name="salesType"
          />
        )}
      </div>
    </div>
  );
};

export default SalesType;
